<mat-card appearance="outlined"><p>email-alerts-intro-dialog works!</p></mat-card>